import React, {useContext, useEffect, useMemo, useState} from 'react';
import {Context} from '../../../Helpers/Auth';
import {useTranslation} from 'react-i18next';
import SelectComponent from '../../Selects/SelectComponent';
import MultiSelect from '../../Selects/MultiSelect';

import {getTiposContratoManutencao, getLubrificantesManutencao, getDuracaoContractoManutencao, getHorasAnoManutencao} from '../../../pages/requests';

function ContratoManutencao({
    editarNegocio,
    tipoContrato,
    setTipoContrato,
    arrayTipoContrato,
    lubrificantes,
    setLubrificantes,
    arrayLubrificantes,
    duracaoContrato,
    setDuracaoContrato,
    arrayDuracaoContrato,
    arrayHorasAno,
    horasAno,
    setHorasAno,
    localTrabalho,
    setLocalTrabalho,
    setOnChangeForm,
    setArrayTipoContrato,
    setArrayLubrificantes,
    setArrayDuracaoContrato,
    setArrayHorasAno,
}) {
    const {t} = useTranslation();

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    useEffect(async () => {
        // contrato
        if (arrayTipoContrato.length == 0) {
            getTiposContratoManutencao(lang).then(res => {
                setArrayTipoContrato(res.data.tipoContratoManutencao);
            });
        }

        // Lubrificantes
        if (arrayLubrificantes.length == 0) {
            getLubrificantesManutencao(lang).then(res => {
                setArrayLubrificantes(res.data.lubrificantesManutencao);
            });
        }

        // Duração
        if (arrayDuracaoContrato.length == 0) {
            getDuracaoContractoManutencao(lang).then(res => {
                setArrayDuracaoContrato(res.data.duracaoContractoManutencao);
            });
        }

        //Horas Ano
        if (arrayHorasAno.length == 0) {
            getHorasAnoManutencao(lang).then(res => {
                setArrayHorasAno(res.data.horasAnoManutencao);
            });
        }
    }, []);

    return (
        <form className="mt-4">
            <div className="grid gap-6 mb-3 md:grid-cols-2">
                <div>
                    <label htmlFor="website" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('tipoContrato')}
                    </label>
                    <SelectComponent
                        isDisabled={!editarNegocio}
                        options={arrayTipoContrato}
                        value={tipoContrato}
                        onChange={e => {
                            setTipoContrato(e);
                            setOnChangeForm(true);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                    />
                </div>
                <div>
                    <label htmlFor="phone" className={`block mb-2 text-sm font-medium text-gray-900 dark:text-white `}>
                        {t('lubrificantes')}
                    </label>
                    <SelectComponent
                        isDisabled={!editarNegocio}
                        options={arrayLubrificantes}
                        value={lubrificantes}
                        onChange={e => {
                            setOnChangeForm(true);
                            setLubrificantes(e);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                    />
                </div>
            </div>
            <div className="grid gap-6 mb-3 md:grid-cols-2">
                <div>
                    <label htmlFor="website" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('duracaoContrato')}
                    </label>
                    <SelectComponent
                        isDisabled={!editarNegocio}
                        options={arrayDuracaoContrato}
                        value={duracaoContrato}
                        onChange={e => {
                            setDuracaoContrato(e);
                            setOnChangeForm(true);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                    />
                </div>
                <div>
                    <label htmlFor="phone" className={`block mb-2 text-sm font-medium text-gray-900 dark:text-white `}>
                        {t('horasAno')}
                    </label>
                    <SelectComponent
                        isDisabled={!editarNegocio}
                        options={arrayHorasAno}
                        value={horasAno}
                        onChange={e => {
                            setOnChangeForm(true);
                            setHorasAno(e);
                        }}
                        noOptionsMessage={t('semopcoes')}
                        placeholder={t('selecioneOpcao')}
                    />
                </div>
            </div>
            <div>
                <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('localTrabalho')}
                </label>
                <input
                    type="text"
                    value={localTrabalho}
                    className={`${
                        !editarNegocio ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                    }  border border-gray-300 text-gray-900 text-sm rounded-[8px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 `}
                    onChange={e => {
                        setLocalTrabalho(e.target.value);
                        setOnChangeForm(true);
                    }}
                    required
                />
            </div>
        </form>
    );
}

export default ContratoManutencao;
